import { computed } from 'vue'
import { Moment } from 'moment'

export default function useDateRange(dateStart: Moment, dateEnd?: Moment) {
  const isDayOnWeekend = (day: number) => [0, 6].includes(day)

  return computed(() => {
    const dateRange = {
      dates: [] as Moment[],
      days: 0,
      week_days: 0,
      weekend_days: 0,
    }
    const datePointer = dateStart.clone().startOf('date')
    if (!dateEnd) {
      dateRange.days++
      if (isDayOnWeekend(datePointer.day())) {
        dateRange.weekend_days++
      } else {
        dateRange.week_days++
      }
    } else {
      while (datePointer <= dateEnd.clone().startOf('date')) {
        dateRange.dates.push(datePointer.clone().startOf('date'))
        dateRange.days++
        if (isDayOnWeekend(datePointer.day())) {
          dateRange.weekend_days++
        } else {
          dateRange.week_days++
        }
        datePointer.add(1, 'days')
      }
    }
    return dateRange
  })
}
